let cache = {};

function addCode(codeBH, codeMap) {
    if (!codeBH) {
        throw new Error('入参codeBH不能为空！');
    }

    if (!codeMap) {
        throw new Error('入参codeMap不能为空！');
    }

    cache[codeBH.toUpperCase()] = codeMap;
}

function addCodeList(codeMapObject) {
    cache = {
        ...cache,
        ...codeMapObject
    };
}

function isCodeExist(codeBH) {
    let keys = Object.keys(cache);
    if (keys && keys.indexOf(codeBH.toUpperCase()) !== -1) {
        return true;
    }

    return false;
}

function getCode(codeBH) {
    return cache[codeBH.toUpperCase()];
}

function clear() {
    cache = {};
}

export default {
    addCode,
    addCodeList,
    getCode,
    isCodeExist,
    clear
};
